export function useTokenHelper() {
  return {
    getToken: async () => localStorage.getItem("jwt"),
  };
}
